import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MockError, mockErrorConfig, MockErrorConfig } from '../../shared/config/mock-error.config';

export abstract class BaseMockService {
    protected serviceName: keyof MockErrorConfig;

    constructor(serviceName: keyof MockErrorConfig) {
        this.serviceName = serviceName;
    }

    protected handle<T>(methodName: string, success$: Observable<T>): Observable<T> {
        const serviceConfig = mockErrorConfig[this.serviceName];
        const errorConfig = serviceConfig?.[methodName] as MockError | undefined;

        if (errorConfig) {
            const errorResponse = new HttpErrorResponse({
                error: errorConfig.body ?? { message: errorConfig.message },
                status: errorConfig.status,
                statusText: errorConfig.message,
            });
            return throwError(() => errorResponse);
        }

        return success$;
    }
}
